export const getConfig = () => {
  const env = import.meta.env.VITE_ENVIRONMENT as string;

  // This should be same but it's splitted for local testing
  const defaultAudience = 'https://api.staging.cloud.brighte.com.au/v2/graphql';
  const defaultUrl = 'https://api.staging.cloud.brighte.com.au/v2/graphql';
  const defaultDatadogProxy = 'https://applynow.staging.cloud.brighte.com.au/api/rum';

  const apiUrlMap: Record<string, string> = {
    uat: 'https://api.uat.cloud.brighte.com.au/v2/graphql',
    prod: 'https://api.brighte.com.au/v2/graphql',
  };

  const datadogProxyMap: Record<string, string> = {
    uat: 'https://applynow.uat.cloud.brighte.com.au/api/rum',
    prod: 'https://applynow.brighte.com.au/api/rum',
  };

  const userScope =
    'offline_access openid profile phone email create:finance-applications-from-quote read:finance-applications update:finance-applications update:finance-applicants read:finance-quotes write:payment-methods read:payment-methods read:finance-referrals';

  return {
    audience: apiUrlMap[env] ?? defaultAudience,
    url: apiUrlMap[env] ?? defaultUrl,
    datadogProxy: datadogProxyMap[env] ?? defaultDatadogProxy,
    userScope,
  };
};
